/* eslint-disable @typescript-eslint/no-unsafe-call */
/* eslint-disable @typescript-eslint/no-unsafe-assignment */
import React, { useState, useEffect } from 'react';
import { Route, Routes, useNavigate, Navigate, useLocation } from 'react-router-dom';
import { ThemeDefault, ThemeRugby, ThemeAFL } from './theme';
import { SPORT_TYPE } from './constants';

import DataLayer, { GTM4Events } from './services/DataLayer';
import Content from './services/Content';
import MixPanel from 'services/MixPanel';
import { IToastContext, ToastContextProvider, IToast } from './components/Toast/ToastContext/ToastContext';
import { GlobalStyle, StyledApp, StyledEnvironmentIndicator } from './App.styled';
import { Toast } from './components/Toast/Toast';
import { TransitionMask } from './components/Transition/TransitionMask/TransitionMask';
import { TransitionContextProvider } from './components/Transition/TransitionContext/TransitionContext';
import { getRoutes, IRoute } from './Routes';
import { ThemeProvider } from 'styled-components';
import Environment, { ENVIRONMENT_TYPE } from './services/Environment';
import { LoadingScreen } from 'components/LoadingScreen/LoadingScreen';
import { Background } from 'components/Background/Background';

const ThemeSportMap = {
  [SPORT_TYPE.AustralianRules]: ThemeAFL,
  [SPORT_TYPE.AustralianRulesOneSession]: ThemeAFL,
  [SPORT_TYPE.Rugby]: ThemeRugby,
  [SPORT_TYPE.WoWTest]: ThemeDefault,
};
const FALLBACK_THEME = ThemeRugby;


export const App: React.FC = () => {
  const environment = Environment.getCurrentEnvironment();
  const loc = useLocation();

  const [isInitialised, setIsInitialised] = useState(false);
  const [selectedTheme, setSelectedTheme] = useState(ThemeDefault); //Pre-authenticated theme
  // Toast context setup
  const [toast, setToast] = useState<IToast | null>(null);
  const toastContext: IToastContext = {
    ...toast,
    setToast: (newToast?: IToast) => setToast(newToast || null),
  };
  const [isloading, setIsloading] = useState<boolean>(true);

  useEffect(() => {
    (() => {
      if (isInitialised) return; // fixes infinite render loop

      DataLayer.init();  //Try to initialise datalayer on mount

      if (!Environment.isEnvironment(ENVIRONMENT_TYPE.LOCAL)) {
        MixPanel.init();
      }
      
      Content.setContentBase();
      setSelectedTheme(ThemeSportMap[SPORT_TYPE.AustralianRules]);

      setIsInitialised(true);
    })();
    
    // show the loading animation, TODO: use this time to prefetch assets
    setTimeout(() => {
      setIsloading(false);
    }, 2000);
  }, []);

  useEffect(()=>{
    //using DataLayer to store previousUrl, since history.block is no longer support in react router v6.
    const previousUrl = DataLayer.getPreviousUrl();
    const route: GTM4Events['pageView'] = {
      current_uri: location.pathname,
      last_uri: previousUrl,
      page_title: 'root',
    };
    DataLayer.pushRouteChange(loc.pathname, previousUrl );
    DataLayer.pushRouteChange_GA4(route);
    DataLayer.setPreviousUrl(window.location.pathname);
  }, [loc]);

  const routes: IRoute[] = getRoutes();
  
  return (
    <ThemeProvider theme={selectedTheme}>
      <StyledApp>
        {!Environment.isEnvironment(ENVIRONMENT_TYPE.PROD) && <StyledEnvironmentIndicator style={{ backgroundColor: environment.tagColor }}>{environment.name}</StyledEnvironmentIndicator>}
        <GlobalStyle />
        
        <TransitionContextProvider>
          <ToastContextProvider value={toastContext}>

            {/* PF we could extend/make a new component for use as an inbetween route animator */}
            <Background overlay={true} unloaded={!isloading}>
              <LoadingScreen/>
            </Background>

            {!isloading &&
             <Routes location={location} key={location.pathname}>
                {routes.map((route, idx) => (
                  <Route
                    key={idx}
                    path={route.path}
                    index={route.index ?? false}
                    element={route.elem}
                  />
                ))}
              </Routes>
            }
            {toast && <Toast toast={toast} />}
          </ToastContextProvider>
          <TransitionMask />
        </TransitionContextProvider>
      </StyledApp>
    </ThemeProvider>
  );
};

export default App;
